import { all, call } from 'typed-redux-saga/macro';
import { attachmentSaga } from './attachment/attachment.saga';
import { authSaga } from './auth/auth.saga';
import { nodeSaga } from './node/node.saga';
import { projectSaga } from './project/project.saga';

export function* rootSaga() {
    yield* all(
        [
            call(authSaga),
            call(projectSaga),
            call(nodeSaga),
            call(attachmentSaga),
        ]
    );
}
